import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useServiceWorker } from '@/hooks/use-browser-notifications'

const LandingPage = lazy(() => import('@/routes/LandingPage').then((module) => ({ default: module.LandingPage })))
const HomePage = lazy(() => import('@/routes/HomePage').then((module) => ({ default: module.HomePage })))
const CreateGatheringPage = lazy(() =>
  import('@/routes/CreateGatheringPage').then((module) => ({ default: module.CreateGatheringPage })),
)
const JoinPage = lazy(() => import('@/routes/JoinPage').then((module) => ({ default: module.JoinPage })))
const GatheringPage = lazy(() =>
  import('@/routes/GatheringPage').then((module) => ({ default: module.GatheringPage })),
)

const RouteFallback = () => (
  <div className="mx-auto flex min-h-screen w-full max-w-[1240px] items-start px-4 pb-28 pt-5 md:px-6 md:pb-16">
    <div className="surface w-full rounded-[34px] px-6 py-8 text-sm text-slate-600">Открываем экран Sbor...</div>
  </div>
)

export const App = () => {
  useServiceWorker()

  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<HomePage />} />
        <Route path="/new" element={<CreateGatheringPage />} />
        <Route path="/join/:inviteToken" element={<JoinPage />} />
        <Route path="/g/:slug" element={<GatheringPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
